import label from "@/lang/StaticLabels.js";

// PWHRS Router  - انبار و کنترل موجودی -----------------------------------------------
let routeItems = {
  path: "PWHRS",
  name: "PWHRS",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  // با کلیک روی ماژول، داشبورد همان ماژول پیش‌فرض باز می‌شود
  redirect: { name: "PWHRSDashboard" },
  children: [
    {
      path: "dashboard",
      name: "PWHRSDashboard",
      meta: {
        label: label.page.dashboard + " " + label.modules.pwhrs,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pwhrs/Dashboard"),
    },
    // Base Information  -----------------------------------------------
    {
      path: "unit",
      name: "PWHRSUnit",
      meta: {
        label: label.page.unit,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pwhrs/base/unit"),
    },
    {
      path: "wareCategory",
      name: "PWHRSWareCategory",
      meta: {
        label: label.page.wareCategory,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pwhrs/base/wareCategory"),
    },
    {
      path: "ware",
      name: "PWHRSWare",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "ware/list",
      children: [
        {
          path: "list",
          name: "PWHRSWareList",
          component: () => import("@/views/modules/pwhrs/base/ware"),
          meta: {
            label: label.page.wares,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PWHRSAddWare",
          component: () => import("@/views/modules/pwhrs/base/ware/Info"),
          meta: {
            label: label.page.addWare,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PWHRSEditWare",
          component: () => import("@/views/modules/pwhrs/base/ware/Info"),
          meta: {
            label: label.page.editWare,
            requiresAuth: true,
          },
        },
        {
          path: "shelf/:id",
          name: "PWHRSWareShelf",
          component: () => import("@/views/modules/pwhrs/base/ware/Shelf"),
          meta: {
            label: label.page.shelf,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "commodityCategory",
      name: "PWHRSCommodityCategory",
      meta: {
        label: label.page.category,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pwhrs/base/commodityCategory"),
    },
    {
      path: "commodityGroupConfig",
      name: "PWHRSCommodityGroupConfig",
      meta: {
        label: label.page.commodityGroupConfig,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pwhrs/base/commodityCategory/config"),
    },
    {
      path: "commodity",
      name: "PWHRSCommodity",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "commodity/list",
      children: [
        {
          path: "list",
          name: "PWHRSCommodityList",
          component: () => import("@/views/modules/pwhrs/base/commodity"),
          meta: {
            label: label.page.commodity,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PWHRSAddCommodity",
          component: () => import("@/views/modules/pwhrs/base/commodity/Info"),
          meta: {
            label: label.page.addCommodity,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PWHRSEditCommodity",
          component: () => import("@/views/modules/pwhrs/base/commodity/Info"),
          meta: {
            label: label.page.editCommodity,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "commodityBatch",
      name: "PWHRSCommodityBatch",
      meta: {
        label: label.page.commodityBatch,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pwhrs/base/commodityBatch"),
    },
    {
      path: "wareVoucherType",
      name: "PWHRSWareVoucherType",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "commodity/list",
      children: [
        {
          path: "list",
          name: "PWHRSWareVoucherTypeList",
          component: () => import("@/views/modules/pwhrs/base/wareVoucherType"),
          meta: {
            label: label.page.wareVoucherType,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PWHRSAddWareVoucherType",
          component: () =>
            import("@/views/modules/pwhrs/base/wareVoucherType/Info"),
          meta: {
            label: label.page.addWareVoucherType,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PWHRSEditWareVoucherType",
          component: () =>
            import("@/views/modules/pwhrs/base/wareVoucherType/Info"),
          meta: {
            label: label.page.editWareVoucherType,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "additionalCommodityParameter",
      name: "PWHRSAdditionalCommodityParameter",
      meta: {
        label: label.page.additionalCommodityParameter,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pwhrs/base/additionalCommodityParameter"),
    },
    {
      path: "packageTypes",
      name: "PWHRSPackageTypes",
      meta: {
        label: label.page.packageTypes,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pwhrs/base/packageTypes"),
    },
    {
      path: "setting",
      name: "PWHRSystemSetting",
      meta: {
        label: label.page.wareSetting,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pwhrs/base/setting"),
    },
    // Operation -----------------------------------------------
    {
      path: "tempReceipt",
      name: "PWHRSTempReceipt",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "tempReceipt/list",
      children: [
        {
          path: "list",
          name: "PWHRSTempReceiptList",
          component: () =>
            import("@/views/modules/pwhrs/operation/tempReceipt"),
          meta: {
            label: label.page.tempReceipt,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PWHRSAddTempReceipt",
          component: () =>
            import("@/views/modules/pwhrs/operation/tempReceipt/Info"),
          meta: {
            label: label.page.addTempReceipt,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PWHRSEditTempReceipt",
          component: () =>
            import("@/views/modules/pwhrs/operation/tempReceipt/Info"),
          meta: {
            label: label.page.editTempReceipt,
            requiresAuth: true,
          },
        },
        {
          path: "cartable",
          name: "PWHRSTempReceiptCartable",
          component: () =>
            import("@/views/modules/pwhrs/operation/tempReceipt/Cartable"),
          meta: {
            label: label.page.tempReceiptCartable,
            requiresAuth: true,
          },
        },
        {
          path: "exitCartable",
          name: "PWHRSTempReceiptExitCartable",
          component: () =>
            import("@/views/modules/pwhrs/operation/tempReceipt/ExitCartable"),
          meta: {
            label: label.page.tempReceiptExitCartable,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "receipt",
      name: "PWHRSReceipt",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "receipt/list",
      children: [
        {
          path: "list",
          name: "PWHRSReceiptList",
          component: () => import("@/views/modules/pwhrs/operation/receipt"),
          meta: {
            label: label.page.receiptList,
            requiresAuth: true,
          },
        },
        {
          path: "addFinancial",
          name: "PWHRSAddFinancialReceipt",
          component: () =>
            import("@/views/modules/pwhrs/operation/receipt/InfoFinancial"),
          meta: {
            label: label.page.addFinancialReceipt,
            requiresAuth: true,
          },
        },
        {
          path: "editFinancial/:id",
          name: "PWHRSEditFinancialReceipt",
          component: () =>
            import("@/views/modules/pwhrs/operation/receipt/InfoFinancial"),
          meta: {
            label: label.page.editFinancialReceipt,
            requiresAuth: true,
          },
        },
        {
          path: "Financialcartable",
          name: "PWHRSFinancialReceiptCartable",
          component: () =>
            import("@/views/modules/pwhrs/operation/receipt/FinancialCartable"),
          meta: {
            label: label.page.financialReceiptCartable,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PWHRSAddSomeWareReceipt",
          component: () =>
            import("@/views/modules/pwhrs/operation/receipt/Info"),
          meta: {
            label: label.page.addSomeWareReceipt,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PWHRSEditSomeWareReceipt",
          component: () =>
            import("@/views/modules/pwhrs/operation/receipt/Info"),
          meta: {
            label: label.page.editSomeWareReceipt,
            requiresAuth: true,
          },
        },
        {
          path: "sort",
          name: "PWHRSSortReceipts",
          component: () =>
            import("@/views/modules/pwhrs/operation/receipt/Sort"),
          meta: {
            label: label.page.sortReceipts,
            requiresAuth: true,
          },
        },
        {
          path: "confirmReceiptCartable",
          name: "PWHRSVerificationReceiptCartable",
          component: () =>
            import(
              "@/views/modules/pwhrs/operation/receipt/VerificationCartable"
            ),
          meta: {
            label: label.page.confirmReceiptCartable,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "draftRequest",
      name: "PWHRSDraftRequest",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "draftRequest/list",
      children: [
        {
          path: "list",
          name: "PWHRSDraftRequestList",
          component: () =>
            import("@/views/modules/pwhrs/operation/draftRequest"),
          meta: {
            label: label.page.draftRequest,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PWHRSAddDraftRequest",
          component: () =>
            import("@/views/modules/pwhrs/operation/draftRequest/Info"),
          meta: {
            label: label.page.addDraftRequest,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PWHRSEditDraftRequest",
          component: () =>
            import("@/views/modules/pwhrs/operation/draftRequest/Info"),
          meta: {
            label: label.page.editDraftRequest,
            requiresAuth: true,
          },
        },
        {
          path: "cartable",
          name: "PWHRSDraftRequestCartable",
          component: () =>
            import("@/views/modules/pwhrs/operation/draftRequest/Cartable"),
          meta: {
            label: label.page.draftRequestCartable,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "draft",
      name: "PWHRSDraft",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "draft/list",
      children: [
        {
          path: "list",
          name: "PWHRSDraftList",
          component: () => import("@/views/modules/pwhrs/operation/draft"),
          meta: {
            label: label.page.draftList,
            requiresAuth: true,
          },
        },
        {
          path: "addFinancial",
          name: "PWHRSAddFinancialDraft",
          component: () =>
            import("@/views/modules/pwhrs/operation/draft/InfoFinancial"),
          meta: {
            label: label.page.addFinancialDraft,
            requiresAuth: true,
          },
        },
        {
          path: "editFinancial/:id",
          name: "PWHRSEditFinancialDraft",
          component: () =>
            import("@/views/modules/pwhrs/operation/draft/InfoFinancial"),
          meta: {
            label: label.page.editFinancialDraft,
            requiresAuth: true,
          },
        },
        {
          path: "Financialcartable",
          name: "PWHRSFinancialDraftCartable",
          component: () =>
            import("@/views/modules/pwhrs/operation/draft/FinancialCartable"),
          meta: {
            label: label.page.financialDraftCartable,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PWHRSAddSomeWareDraft",
          component: () => import("@/views/modules/pwhrs/operation/draft/Info"),
          meta: {
            label: label.page.addSomeWareDraft,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PWHRSEditSomeWareDraft",
          component: () => import("@/views/modules/pwhrs/operation/draft/Info"),
          meta: {
            label: label.page.editSomeWareDraft,
            requiresAuth: true,
          },
        },
        {
          path: "sort",
          name: "PWHRSSortDrafts",
          component: () => import("@/views/modules/pwhrs/operation/draft/Sort"),
          meta: {
            label: label.page.sortDrafts,
            requiresAuth: true,
          },
        },
        {
          path: "confirmDraftCartable",
          name: "PWHRSVerificationDraftCartable",
          component: () =>
            import(
              "@/views/modules/pwhrs/operation/draft/VerificationCartable"
            ),
          meta: {
            label: label.page.confirmDraftCartable,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "transferCommodity",
      name: "PWHRSTransferCommodity",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "transferCommodity/list",
      children: [
        {
          path: "list",
          name: "PWHRSTransferCommodityList",
          component: () =>
            import("@/views/modules/pwhrs/operation/transferCommodity"),
          meta: {
            label: label.page.transferCommodity,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PWHRSAddInstantTransfer",
          component: () =>
            import("@/views/modules/pwhrs/operation/transferCommodity/Add"),
          meta: {
            label: label.page.addInstantTransfer,
            requiresAuth: true,
          },
        },
        {
          path: "addProccess",
          name: "PWHRSAddProccessTransfer",
          component: () =>
            import(
              "@/views/modules/pwhrs/operation/transferCommodity/AddProccess"
            ),
          meta: {
            label: label.page.addProccessTransfer,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PWHRSEditInstantTransfer",
          component: () =>
            import("@/views/modules/pwhrs/operation/transferCommodity/Add"),
          meta: {
            label: label.page.editInstantTransfer,
            requiresAuth: true,
          },
        },
        {
          path: "editProccess/:id",
          name: "PWHRSEditProccessTransfer",
          component: () =>
            import(
              "@/views/modules/pwhrs/operation/transferCommodity/AddProccess"
            ),
          meta: {
            label: label.page.editProccessTransfer,
            requiresAuth: true,
          },
        },
        {
          path: "proccessTransferCartable",
          name: "PWHRSProccessTransferCartable",
          meta: {
            label: label.page.proccessTransferCartable,
            requiresAuth: true,
          },
          component: () =>
            import(
              "@/views/modules/pwhrs/operation/transferCommodity/Cartable"
            ),
        },
      ],
    },
    {
      path: "commodityConversion",
      name: "PWHRSCommodityConversion",
      meta: {
        label: label.page.commodityConversion,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pwhrs/operation/commodityConversion/Add"),
    },
    {
      path: "cartableLog",
      name: "PWHRSCartableLog",
      meta: {
        label: label.page.cartableLog,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pwhrs/operation/cartableLog"),
    },
    {
      path: "warehousing",
      name: "PWHRSWarehousing",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "warehousing/list",
      children: [
        {
          path: "list",
          name: "PWHRSWarehousingList",
          component: () =>
            import("@/views/modules/pwhrs/operation/warehousing"),
          meta: {
            label: label.page.warehousing,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PWHRSAddWarehousing",
          component: () =>
            import("@/views/modules/pwhrs/operation/warehousing/Info"),
          meta: {
            label: label.page.addWarehousing,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PWHRSEditWarehousing",
          component: () =>
            import("@/views/modules/pwhrs/operation/warehousing/Info"),
          meta: {
            label: label.page.editWarehousing,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "managementCartable",
      name: "PWHRSManagementCartable",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "managementCartable/receipt",
      children: [
        {
          path: "receipt",
          name: "PWHRSManagementCartableReceipt",
          component: () =>
            import(
              "@/views/modules/pwhrs/operation/managementCartable/Receipt"
            ),
          meta: {
            label: label.page.managementCartableReceipt,
            requiresAuth: true,
          },
        },
        {
          path: "draft",
          name: "PWHRSManagementCartableDraft",
          component: () =>
            import("@/views/modules/pwhrs/operation/managementCartable/Draft"),
          meta: {
            label: label.page.managementCartableDraft,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "financialCartable",
      name: "PWHRSFinancialCartable",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "financialCartable/buyFactor",
      children: [
        {
          path: "buyFactor",
          name: "PWHRSIssueBuyFactor",
          component: () =>
            import("@/views/modules/pwhrs/operation/financialCartable"),
          props: { factorType: "buy" },
          meta: {
            label: label.page.issueBuyFactor,
            requiresAuth: true,
          },
        },
        {
          path: "returnSaleFactor",
          name: "PWHRSIssueReturnSaleFactor",
          component: () =>
            import("@/views/modules/pwhrs/operation/financialCartable"),
          props: { factorType: "returnSale" },
          meta: {
            label: label.page.issueReturnSaleFactor,
            requiresAuth: true,
          },
        },
        {
          path: "saleFactor",
          name: "PWHRSIssueSaleFactor",
          component: () =>
            import("@/views/modules/pwhrs/operation/financialCartable"),
          props: { factorType: "sale" },
          meta: {
            label: label.page.issueSaleFactor,
            requiresAuth: true,
          },
        },
        {
          path: "returnBuyFactor",
          name: "PWHRSIssueReturnBuyFactor",
          component: () =>
            import("@/views/modules/pwhrs/operation/financialCartable"),
          props: { factorType: "returnBuy" },
          meta: {
            label: label.page.issueReturnBuyFactor,
            requiresAuth: true,
          },
        },
      ],
    },
    
    // Reports -----------------------------------------------
    {
      path: "reports",
      name: "PWHRSReports",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "reports/someVouchers",
      children: [
        {
          path: "someVouchers",
          name: "PWHRSSomeVouchers",
          component: () =>
            import("@/views/modules/pwhrs/reports/wareVouchers/Some"),
          meta: {
            label: label.page.wareSomeVouchers,
            requiresAuth: true,
          },
        },
        {
          path: "financialVouchers",
          name: "PWHRSFinancialVouchers",
          component: () =>
            import("@/views/modules/pwhrs/reports/wareVouchers/Financial"),
          meta: {
            label: label.page.wareFinancialVouchers,
            requiresAuth: true,
          },
        },
        {
          path: "someCirculation",
          name: "PWHRSSomeCirculation",
          component: () =>
            import("@/views/modules/pwhrs/reports/circulationCommodity/Some"),
          meta: {
            label: label.page.someCirculation,
            requiresAuth: true,
          },
        },
        {
          path: "financialCirculation",
          name: "PWHRSFinancialCirculation",
          component: () =>
            import(
              "@/views/modules/pwhrs/reports/circulationCommodity/Financial"
            ),
          meta: {
            label: label.page.financialCirculation,
            requiresAuth: true,
          },
        },
        {
          path: "inventoryDeduction",
          name: "PWHRSInventoryDeduction",
          component: () =>
            import(
              "@/views/modules/pwhrs/reports/otherReports/InventoryDeduction"
            ),
          meta: {
            label: label.page.inventoryDeductionReport,
            requiresAuth: true,
          },
        },
        {
          path: "inventorySummary",
          name: "PWHRSInventorySummaryReport",
          component: () =>
            import(
              "@/views/modules/pwhrs/reports/otherReports/InventorySummary"
            ),
          meta: {
            label: label.page.inventorySummaryReport,
            requiresAuth: true,
          },
        },
        {
          path: "commoditySleep",
          name: "PWHRSCommoditySleepReport",
          component: () =>
            import(
              "@/views/modules/pwhrs/reports/otherReports/CommoditySleepReport"
            ),
          meta: {
            label: label.page.commoditySleepReport,
            requiresAuth: true,
          },
        },
        {
          path: "commodityCirculation",
          name: "PWHRSCommodityCirculationReport",
          component: () =>
            import(
              "@/views/modules/pwhrs/reports/otherReports/CommodityCirculationReport"
            ),
          meta: {
            label: label.page.commodityCirculationReport,
            requiresAuth: true,
          },
        },
        {
          path: "negativeCommodityInventory",
          name: "PWHRSNegativeCommodityInventory",
          component: () =>
            import(
              "@/views/modules/pwhrs/reports/otherReports/NegativeCommodityInventory"
            ),
          meta: {
            label: label.page.negativeCommodityInventory,
            requiresAuth: true,
          },
        },
        {
          path: "someInventory",
          name: "PWHRSSomeInventory",
          component: () =>
            import("@/views/modules/pwhrs/reports/wareInventory/Some"),
          meta: {
            label: label.page.someInventory,
            requiresAuth: true,
          },
        },
        {
          path: "financialInventory",
          name: "PWHRSFinancialInventory",
          component: () =>
            import("@/views/modules/pwhrs/reports/wareInventory/Financial"),
          meta: {
            label: label.page.financialInventory,
            requiresAuth: true,
          },
        },
        {
          path: "someCardex",
          name: "PWHRSSomeCardex",
          component: () => import("@/views/modules/pwhrs/reports/cardex/Some"),
          meta: {
            label: label.page.someCardex,
            requiresAuth: true,
          },
        },
        {
          path: "financialCardex",
          name: "PWHRSFinancialCardex",
          component: () =>
            import("@/views/modules/pwhrs/reports/cardex/Financial"),
          meta: {
            label: label.page.financialCardex,
            requiresAuth: true,
          },
        },
      ],
    },
  ],
};

export default routeItems;
